// extracted by mini-css-extract-plugin
export default {"OptionItem":"OptionItem__OptionItem___pq5_i","name":"OptionItem__name___f4CfS","code":"OptionItem__code___KH68V"};